
export class ConvertProviderValueConverter {
           /**
            * @param str      provider key
            * @param classes  optional provider key -> css class list map (from the
            *                 product provider configuration, so that providers in
            *                 the same group resolve to the same accent class).
            *                 When passed, the returned value already carries the
            *                 "type-" prefix.
            */
           toView(str, classes) {
               if (!str) {
                   return '';
               }

               if (undefined !== classes) {
                   return classes[str] ?? 'type-' + str.replace('/', '-');
               }

               return str.replace('/', '-');
           }
       }
